var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account",staticStyle:{"background":"#fff"}},[_c('accountForm',{attrs:{"isEdit":_vm.isEdit,"formObjError":_vm.formObjError},on:{"accountWay":_vm.addAccount}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }